import { useState } from "react";
import { Artist } from "../../../types/type";

interface ArtistUserCardProps {
  artist?: Artist;
  userIdList: string[];
  onProcessUsers: ({
    userIdList,
    artistId,
  }: {
    userIdList: string[];
    artistId: string;
  }) => void;
}

const ArtistUserCard: React.FC<ArtistUserCardProps> = ({
  artist,
  userIdList,
  onProcessUsers,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const displayUsers = isExpanded ? userIdList : userIdList.slice(0, 5);
  const hasMore = userIdList.length > 5;

  if (!artist) {
    return null;
  }

  return (
    <div
      style={{
        border: "1px solid #ccc",
        padding: "16px",
        borderRadius: "8px",
        marginBottom: "16px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <h3 style={{ fontWeight: "600" }}>
            {artist.artistName} ({artist.artistId})
          </h3>
          <p style={{ color: "#666", fontSize: "14px", marginTop: "4px" }}>
            팔로워: {artist.followerIdList.length} | 곡:{" "}
            {artist.songIdList.length}
          </p>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <button
            onClick={() =>
              onProcessUsers({ userIdList, artistId: artist.artistId })
            }
            style={{
              backgroundColor: "#007bff",
              color: "white",
              padding: "8px 16px",
              borderRadius: "4px",
              cursor: "pointer",
              border: "none",
            }}
          >
            알림 보내기 ({userIdList.length}명)
          </button>
          {hasMore && (
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              style={{
                color: "#007bff",
                cursor: "pointer",
                textDecoration: "underline",
                background: "none",
                border: "none",
              }}
            >
              {isExpanded ? "접기" : `더보기 (${userIdList.length - 5}명)`}
            </button>
          )}
        </div>
      </div>
      <div style={{ marginTop: "8px" }}>
        <p>Users ({userIdList.length}):</p>
        <ul
          style={{
            listStyleType: "disc",
            paddingLeft: "24px",
            maxHeight: isExpanded ? "none" : "150px",
            overflow: "hidden",
            transition: "max-height 0.3s ease-in-out",
          }}
        >
          {displayUsers.map((userId) => (
            <li key={userId}>{userId}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ArtistUserCard;
